//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DpControlGroup',
  props: {
    stretch: { type: Boolean, default: false },
    spread: { type: Boolean, default: false },
    inline: { type: Boolean, default: false },
    spaced: { type: Boolean, default: false },
    centered: { type: Boolean, default: false },
    leftAligned: { type: Boolean, default: false },
    rightAligned: { type: Boolean, default: false },
    topAligned: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    fitText: { type: Boolean, default: false },
  },
};
